import { z } from 'zod';
import { ManagerUserSchema } from '../user/user.schema';
/**
 * Department Schema
 * Represents a department entity in the organization
 * Matches the backend database schema
 */ export const DepartmentSchema = z.object({
    _id: z.string(),
    name: z.string(),
    description: z.string().optional(),
    abbreviation: z.string(),
    path: z.string().optional(),
    manager: z.lazy(()=>ManagerUserSchema).optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
    deletedAt: z.number().optional()
});
/**
 * Populated Department Schema
 * Used when department references are populated with full department data
 * Simplified version for display purposes
 */ export const PopulatedDepartmentSchema = z.object({
    _id: z.string(),
    name: z.string(),
    abbreviation: z.string(),
    manager: z.lazy(()=>ManagerUserSchema).optional()
});

//# sourceMappingURL=department.schema.js.map